import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

import { MIN_CHARS } from '../../constants'

const NotEnoughCharacters = styled.span`
    display: block;
    text-align: right;
    color: red;
`

const AcknowledgeResolution = ({
    options,
    state: {
        closeAlarm: { workOrder, extra = { resolution: '', resolutionDetails: '' } }
    },
    dispatch
}) => {
    const { resolution, resolutionDetails } = extra

    const isOther = (resolution || '').toLowerCase() === 'other'
    const notEnoughCharacters = isOther && resolutionDetails.trim().length < MIN_CHARS
    const currentCharacters = resolutionDetails.trim().length

    const textareaRef = useRef(null)

    useEffect(() => {
        if (!resolution || !workOrder) {
            dispatch({
                type: 'updateCloseAlarm',
                data: {
                    ...(resolution ? {} : { extra: { resolution: options[0].resolution, resolutionDetails: '' } }),
                    ...(workOrder ? {} : { workOrder: 'N/A' })
                }
            })
        }
    }, [resolution, workOrder, dispatch, options])

    return (
        <div className="form-group">
            <label>Resolution:</label>

            <div>
                {options.map((option, i) => (
                    <label key={i} className="radio">
                        <input
                            type="radio"
                            name={option.resolution}
                            value={option.resolution}
                            checked={resolution.toLowerCase() === option.resolution.toLowerCase()}
                            onChange={({ target }) =>
                                dispatch({
                                    type: 'updateCloseAlarm',
                                    data: { extra: { ...extra, resolution: target.value } }
                                })
                            }
                        />
                        <span>{option.resolution}</span>
                    </label>
                ))}
            </div>

            <textarea
                ref={textareaRef}
                value={isOther ? resolutionDetails : ''}
                onChange={({ target }) =>
                    dispatch({
                        type: 'updateCloseAlarm',
                        data: { extra: { ...extra, resolutionDetails: target.value } }
                    })
                }
                disabled={!isOther}
                style={{
                    border: notEnoughCharacters ? '1px solid red' : ''
                }}
            />
            {notEnoughCharacters && (
                <NotEnoughCharacters>
                    Resolution details text too short (currently {currentCharacters} characters, minimum is {MIN_CHARS})
                </NotEnoughCharacters>
            )}
        </div>
    )
}

export default AcknowledgeResolution
